import { render, staticRenderFns } from "./UnsavedCommentModal.vue?vue&type=template&id=52a5a230&"
import script from "./UnsavedCommentModal.vue?vue&type=script&lang=js&"
export * from "./UnsavedCommentModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports